import React from "react";
import SponcerLargebanner from "../components/sponcerLargebanner";
import SponcerBillboard from "../components/sponcerBillboard";
import SponcerBanner from "../components/sponcerbanner";
import SponcerCard from "../components/sponcerCard";

function AdsPage() {
  return (
    <div className="ads-page">
      <h1 className="text-center text-2xl font-bold my-4">Advertisements</h1>

      <section className="my-8">
        <h2 className="text-xl font-semibold text-center mb-4">
          Large Leaderboard
        </h2>
        <SponcerLargebanner />
      </section>

      <section className="my-8">
        <h2 className="text-xl font-semibold text-center mb-4">Billboard</h2>
        <SponcerBillboard />
      </section>

      <section className="my-8">
        <h2 className="text-xl font-semibold text-center mb-4">Leaderboard</h2>
        <SponcerBanner />
      </section>

      <section className="my-8">
        <h2 className="text-xl font-semibold text-center mb-4">
          Medium Rectangle
        </h2>
        <SponcerCard />
      </section>
    </div>
  );
}

export default AdsPage;
